angular.module("tikonApp")
    .directive("eoHelpTooltip", ['AlertService', function (alertService) {
        return {
            restrict: 'AE',
            replace: 'false',
            template: "",
            link: function (scope, elem, attrs) {
                var helpIcon = $('<a id=""' + attrs.eoHelpTooltip + '"><span  style="color: #a3ddf9;font-size: 17px;margin: 5px; top: 5px;" class="glyphicon glyphicon-question-sign"></span></a>');
                helpIcon.bind('click', function () {
                    alertService.showHelpMessage(helpIcon, attrs.eoHelpTooltip);
                    //alert(attrs.eoHelpTooltip);
                })
                helpIcon.insertAfter(elem);
                //elem.bind('click', function () {
                //    elem.css('background-color', 'white');
                //    scope.$apply(function () {
                //        scope.color = "white";
                //    });
                //});
                //elem.bind('mouseover', function () {
                //    elem.css('cursor', 'pointer');
                //});
            }
        };
    }]);


(function () {
    'use strict';
    HelpTipController.$inject = ['$scope', '$attrs', '$element', 'AlbumInfo', 'AlbumInfoExtend', 'DataUtils', 'ImageDataExtended', '$timeout'];

    function HelpTipController($scope, $attrs, $element, AlbumInfo, AlbumInfoExtend, DataUtils, ImageDataExtended, $timeout) {
//
        var $ctrl = this;


    }


    var HelpTip = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/help-tip/eyeson.help-tip.html',
        controller: HelpTipController,
        bindings: {
            text: '@'
        }

    };

    angular
        .module('tikonApp')
        .component('eoHelpTip', HelpTip)


})();

